import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { loginSuccess, logout, setAccessToken } from "store/slices/authSlice";
import { useUpdateAccessTokenMutation } from "features/auth/api/authApi";
import { useLazyGetUserQuery } from "entities/user/api/userApi";
import { hasPendingTwoFactorInUrl } from "shared/utils/pending2fa";

export const useInitAuth = () => {
  const dispatch = useDispatch();
  const [isInitializing, setIsInitializing] = useState(true);
  const initiated = useRef(false);

  const [updateAccessToken] = useUpdateAccessTokenMutation();
  const [getUser] = useLazyGetUserQuery();

  useEffect(() => {
    if (initiated.current) return;
    initiated.current = true;

    const initSession = async () => {
      if (hasPendingTwoFactorInUrl()) {
        setIsInitializing(false);
        return;
      }

      try {
        const { access_token } = await updateAccessToken().unwrap();
        dispatch(setAccessToken(access_token));
        const user = await getUser(undefined, true).unwrap();
        dispatch(loginSuccess({ access_token, user }));
      } catch {
        dispatch(logout());
      } finally {
        setIsInitializing(false);
      }
    };

    initSession();
  }, [dispatch, getUser, updateAccessToken]);

  return { isInitializing };
};
